import { useEffect, useRef } from "react";

const ARROW_OFFSET_PERCENTAGE = 0.05;

export const useArrowPositioning = (showEmptyState) => {
  const selectorsRef = useRef(null);
  const emptyStateRef = useRef(null);

  useEffect(() => {
    if (!showEmptyState || !selectorsRef.current || !emptyStateRef.current) {
      return;
    }

    const updateArrowRight = () => {
      const container = emptyStateRef.current.getBoundingClientRect();
      const selectors = selectorsRef.current.getBoundingClientRect();
      const rightOffsetPx =
        container.right -
        selectors.right +
        container.width * ARROW_OFFSET_PERCENTAGE;
      emptyStateRef.current.style.setProperty(
        "--arrow-right-offset",
        `${rightOffsetPx}px`,
      );
    };

    updateArrowRight();

    const resizeObserver = new ResizeObserver(updateArrowRight);
    resizeObserver.observe(emptyStateRef.current);

    const headerEl = selectorsRef.current.closest(".ant-page-header");
    if (headerEl) {
      resizeObserver.observe(headerEl);
    }

    return () => resizeObserver.disconnect();
  }, [showEmptyState]);

  return {
    selectorsRef,
    emptyStateRef,
  };
};
